/// <amd-module name="Repos/Highlight/Components/HighlightableSpan" />
import * as React from "react";

export interface HighlightableSpanProps {
    className?: string;
    text: string;
    highlight?: string;
}

export const HighlightableSpan = (props: HighlightableSpanProps): JSX.Element => {
    if (!props.highlight) {
        return <span className={props.className}>{props.text}</span>;
    }

    return <span className={props.className}>{getHighlightChildren(props)}</span>;
};

function getHighlightChildren({ text, highlight }: HighlightableSpanProps): React.ReactNode[] {
    const results: React.ReactNode[] = [];
    const regularParts = text.toLocaleLowerCase().split(highlight!.toLocaleLowerCase());
    let position = 0;

    function add(part: string, element?: JSX.Element) {
        results.push(element || part);
        position += part.length;
    }

    for (let index = 0; index < regularParts.length; index++) {
        if (index > 0) {
            const part = text.substr(position, highlight!.length);
            add(part, <mark key={position}>{part}</mark>);
        }

        add(text.substr(position, regularParts[index].length));
    }

    return results;
}
